<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 引入统一设计系统（变量 + 全局组件类） */
@import './assets/global.css';
</style>